module.exports = __webpack_public_path__ + "static/media/bluecircle.5d8b2474.svg";